import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';

// Only app-relative destinations may cross the identity round trip. Auth entry
// routes would restart the flow, so treat them like an absent destination.
export const getAuthRedirectPath = (appState: unknown): string => {
  if (
    !appState ||
    typeof appState !== 'object' ||
    !('redirectPath' in appState) ||
    typeof appState.redirectPath !== 'string'
  ) {
    return APP_MANAGED_ROUTES.HOME;
  }

  const path = appState.redirectPath;
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\')) {
    return APP_MANAGED_ROUTES.HOME;
  }

  try {
    const destination = new URL(path, window.location.origin);
    // React Router decodes route segments and matches case-insensitively.
    // Validate that representation without changing the returned deep link.
    const pathname = decodeURIComponent(destination.pathname).toLowerCase();
    if (
      destination.origin !== window.location.origin ||
      destination.pathname.startsWith('//') ||
      pathname.startsWith('//') ||
      [
        APP_MANAGED_ROUTES.LANDING_PAGE,
        APP_MANAGED_ROUTES.SIGN_IN,
        APP_MANAGED_ROUTES.SIGN_OUT,
        APP_MANAGED_ROUTES.START_LOGIN,
      ].some(
        (entry) =>
          pathname === entry ||
          (entry !== '/' && pathname.startsWith(`${entry}/`)),
      )
    ) {
      return APP_MANAGED_ROUTES.HOME;
    }

    return `${destination.pathname}${destination.search}${destination.hash}`;
  } catch {
    return APP_MANAGED_ROUTES.HOME;
  }
};
